import React from 'react'
import { useForm, Form, Field } from '../../../form'
import { push } from 'redux-first-history'
import { useSelector, useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'
import Snackbar from '@material-ui/core/Snackbar'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import LinearProgress from '@material-ui/core/LinearProgress'
import Button from '@material-ui/core/Button'
import Paper from '@material-ui/core/Paper'
import { MySnackbarContentWrapper } from '../../../utils/snackbar.utils'
import { loginValidate } from '../../../containers/employer/validate'
import {
  loginFormSubmit,
  closeLoginSnackbar,
  hideResetPasswordSnackbar,
  getLangFromSite
} from '../../../actions/employer'
import { faqFunction } from '../../../utils/website.utils'
import ResetPassword from '../../../containers/employer/resetPassword.container'
import { Translation } from 'react-i18next'

const styles = (theme) => ({
  button: {
    width: '100%'
  },
  textField: {
    marginTop: theme.spacing(4),
    minWidth: 100,
    border: '1px solid gray'
  },
  resize: {
    fontSize: '14px'
  },
  progress: {
    flexGrow: 1
  }
})

const defaultValues = {
  email: '',
  password: ''
}

const LoginComponent = ({ classes }) => {
  const dispatch = useDispatch()
  const form = useForm({
    name: 'login',
    onSubmit: onSubmit,
    defaultValues: defaultValues,
    validator: loginValidate,
    resetOnSubmit: false
  })

  const { control } = form

  React.useEffect(() => {
    dispatch(getLangFromSite())
    if (client.user) dispatch(push('/dashboard/lightEntrepreneurs'))
    faqFunction()
  }, [])

  function onSubmit(values) {
    dispatch(loginFormSubmit(values))
  }

  const { showSpinner, showFailSnackbar, errorMsg } = useSelector(
    (state) => state.login
  )

  const { showResetPassSnackbar, showResetFailSnackbar } = useSelector(
    (state) => state.resetPassword
  )

  const client = useSelector((state) => state.client)

  function unFreeze(e) {
    //fixes bug caused by autofill where clicking on a textfield
    //doesn't properly focus on the input after logging out
    //https://stackoverflow.com/questions/58201291/chrome-autocomplete-lock-inputs-like-they-are-not-clickable
    e.target.value = e.target.value
  }

  return (
    <Translation>
      {(t) => (
        <div className="form-login-container">
          <Form {...form}>
            <div>
              <Paper className="panel-body form-login-content">
                <div>
                  <Field
                    label={t('employer.login.email')}
                    name="email"
                    type="text"
                    inputType="textfield"
                    className={classNames(classes.textField, classes.resize)}
                    control={control}
                    onClick={unFreeze}
                  />
                </div>
                <div>
                  <Field
                    label={t('employer.login.psw')}
                    type="password"
                    name="password"
                    inputType="textfield"
                    className={classNames(classes.textField, classes.resize)}
                    control={control}
                    onClick={unFreeze}
                  />
                </div>
                <div className="form-login-button">
                  <Button
                    variant="contained"
                    className={classes.button}
                    type="submit"
                  >
                    {t('employer.login.kirjaudu')}
                  </Button>
                </div>
              </Paper>
              <div className="form-login-registerLink">
                <Paper className="form-login-register">
                  <p style={{ paddingTop: '15px' }}>
                    {t('employer.login.p1')}{' '}
                    <Link to="/dashboard/employerRegister">
                      {t('employer.login.luo')}
                    </Link>{' '}
                  </p>
                </Paper>
              </div>
            </div>
          </Form>
          <div className="form-login-resetPassword">
            <Paper className="faqpanels">
              <div className="collapsepanel">
                <div className="title">{t('employer.login.p_title')}</div>
                <div className="content">
                  <p>{t('employer.login.p_content')}</p>
                  <ResetPassword />
                </div>
              </div>
            </Paper>
          </div>
          <Snackbar
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center'
            }}
            open={showResetPassSnackbar}
            autoHideDuration={4000}
            onClose={() => {
              dispatch(hideResetPasswordSnackbar())
            }}
          >
            <MySnackbarContentWrapper
              onClose={() => {
                dispatch(hideResetPasswordSnackbar())
              }}
              variant="success"
              message={t('employer.login.msg1')}
            />
          </Snackbar>
          <Snackbar
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center'
            }}
            open={showResetFailSnackbar}
            autoHideDuration={4000}
            onClose={() => {
              dispatch(hideResetPasswordSnackbar())
            }}
          >
            <MySnackbarContentWrapper
              onClose={() => {
                dispatch(hideResetPasswordSnackbar())
              }}
              variant="error"
              message={t('employer.login.msg2')}
            />
          </Snackbar>
          <Snackbar
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center'
            }}
            open={showFailSnackbar}
            autoHideDuration={4000}
            onClose={() => {
              dispatch(closeLoginSnackbar())
            }}
          >
            <MySnackbarContentWrapper
              onClose={() => {
                dispatch(closeLoginSnackbar())
              }}
              variant="error"
              message={
                errorMsg === 'user not found'
                  ? t('employer.login.msg3a')
                  : t('employer.login.msg3')
              }
            />
          </Snackbar>
          <Dialog
            open={showSpinner}
            aria-describedby="alert-dialog-description"
          >
            <DialogContent>
              <DialogContentText
                id="alert-dialog-description"
                style={{ fontSize: '15px', margin: '20px' }}
              >
                {t('employer.login.dialog')}
              </DialogContentText>
            </DialogContent>
            <div className={classes.progress}>
              <LinearProgress />
            </div>
          </Dialog>
        </div>
      )}
    </Translation>
  )
}

export default withStyles(styles)(LoginComponent)
